import React, { useEffect, useState } from "react";
import "../styles/ProductLightbox.css";

const ProductLightbox = ({ product, onClose, onAddToCart }) => {
  const [zoomPosition, setZoomPosition] = useState({ x: 0, y: 0 });
  const [showZoom, setShowZoom] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleEsc);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", handleEsc);
      document.body.style.overflow = "unset";
    };
  }, [onClose]);

  if (!product) return null;

  const imageUrl = `${process.env.PUBLIC_URL}/images/${product.codigo}.webp`;
  const defaultImage = `${process.env.PUBLIC_URL}/images/placeholder.webp`;

  const handleMouseMove = (e) => {
    const { left, top, width, height } = e.target.getBoundingClientRect();
    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;
    setZoomPosition({
      x: Math.min(Math.max(x, 0), 100),
      y: Math.min(Math.max(y, 0), 100),
    });
  };

  return (
    <div className="lightbox-overlay" onClick={onClose}>
      <div className="lightbox-container" onClick={(e) => e.stopPropagation()}>
        <button className="lightbox-close" onClick={onClose}>
          ✕
        </button>

        <div className="lightbox-content">
          {/* Área de la imagen con zoom */}
          <div className="lightbox-image-area">
            <div
              className="image-zoom-container"
              onMouseMove={handleMouseMove}
              onMouseEnter={() => setShowZoom(true)}
              onMouseLeave={() => setShowZoom(false)}
            >
              <img
                src={imageUrl}
                alt={product.nombre}
                className="lightbox-image"
                onError={(e) => {
                  e.target.src = defaultImage;
                  e.target.onerror = null;
                }}
                onLoad={() => setImageLoaded(true)}
              />

              {showZoom && imageLoaded && (
                <div
                  className="zoom-lens"
                  style={{
                    left: `${zoomPosition.x}%`,
                    top: `${zoomPosition.y}%`,
                  }}
                />
              )}
            </div>

            {showZoom && imageLoaded && (
              <div className="zoom-result">
                <div
                  className="zoom-result-image"
                  style={{
                    backgroundImage: `url(${imageUrl})`,
                    backgroundPosition: `${zoomPosition.x}% ${zoomPosition.y}%`,
                    backgroundSize: "200% auto",
                  }}
                />
              </div>
            )}
          </div>

          <div className="lightbox-info">
            <h2>{product.nombre}</h2>
            <p className="lightbox-code">🔖 Código: {product.codigo}</p>
            <p className="lightbox-unit">📦 Unidad: {product.unidad}</p>

            <div className="lightbox-price-section">
              <span className="lightbox-price">
                💰 {product.precio.toFixed(2)}
              </span>
              <span className="lightbox-price">
                ({product.pv_usd.toFixed(2)} USD)
              </span>
              <span
                className={`lightbox-stock ${product.disponible ? "in-stock" : "out-stock"}`}
              >
                {product.disponible
                  ? `✅ Stock: ${product.cantidad} ${product.unidad}`
                  : "❌ Agotado"}
              </span>
            </div>

            <div className="lightbox-description">
              <h3>📝 Descripción</h3>
              <p>
                {product.descripcion ||
                  `${product.nombre} - Producto de alta calidad. 
                Ideal para uso profesional y doméstico.`}
              </p>
            </div>
            <div className="zoom-instruction">
              🔍 Pasa el mouse sobre la imagen para hacer zoom
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductLightbox;
